import { FolderResponse } from '../../../../shared/models/documents-response.model';

export class MembershipSharedService {
  static isMoaType(docType: string | undefined | null): boolean {
    if (!docType) {
      return false;
    }
    const normalized = docType.toLowerCase().replace(/[\s_]+/g, ' ');
    return normalized.includes('memorandum') && normalized.includes('association');
  }

  static hasMoaInSr(srFolder?: FolderResponse): boolean {
    const documents = srFolder?.documents;
    return Array.isArray(documents)
      ? documents.some((doc:any) => MembershipSharedService.isMoaType((doc as any)?.documentType) && !doc?.memberFolderId)
      : false;
  }

  /**
   * Called when owners/signatories are added/updated to ensure MOA is re-uploaded.
   * If SR already has an MOA, nothing is removed.
   * Returns updated SR folder, member docs, and a flag indicating future member-doc fetches
   * should remove MOA if not present yet.
   */
  static clearMoaAfterOwnerChange<T extends { documentType?: string }>(
    srFolder: FolderResponse | undefined,
    memberDocuments: T[] = []
  ): { srFolder: FolderResponse | undefined; memberDocuments: T[]; shouldClearMoaFromMemberDocs: boolean } {
    const hasExistingMoaInSr = MembershipSharedService.hasMoaInSr(srFolder);
    if (hasExistingMoaInSr) {
      return { srFolder, memberDocuments, shouldClearMoaFromMemberDocs: false };
    }

    let updatedSrFolder:any = srFolder;
    const documents = srFolder?.documents;
    if (Array.isArray(documents)) {
      const filteredDocuments = documents.filter((doc: any) => !MembershipSharedService.isMoaType(doc?.documentType));
      if (filteredDocuments.length !== documents.length) {
        updatedSrFolder = { ...(srFolder ?? {}), documents: filteredDocuments };
      }
    }

    const filteredMemberDocs = memberDocuments.filter(
      (doc: any) => !MembershipSharedService.isMoaType(doc?.documentType)
    );
    const removedNow = filteredMemberDocs.length !== memberDocuments.length;

    return {
      srFolder: updatedSrFolder,
      memberDocuments: filteredMemberDocs,
      shouldClearMoaFromMemberDocs: removedNow ? false : true
    };
  }

  /**
   * Applies pending MOA clearing on member documents when they are fetched/merged.
   */
  static applyPendingMoaClear<T extends { documentType?: string }>(
    memberDocuments: T[] = [],
    shouldClearMoaFromMemberDocs: boolean
  ): { memberDocuments: T[]; shouldClearMoaFromMemberDocs: boolean } {
    if (!shouldClearMoaFromMemberDocs) {
      return { memberDocuments, shouldClearMoaFromMemberDocs };
    }
    const filtered = memberDocuments.filter(
      (doc: any) => !MembershipSharedService.isMoaType(doc?.documentType)
    );
    const removedNow = filtered.length !== memberDocuments.length;
    return {
      memberDocuments: filtered,
      shouldClearMoaFromMemberDocs: removedNow ? false : shouldClearMoaFromMemberDocs
    };
  }
}
